import { useRef, useState } from 'react';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import excelFile from "../../../ExcelFiles/TrackingBuilkbooking.xlsx";
import { postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";

const TrackingBulk = () => {
  const [excelData, setExcelData] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [errorFileUrl, setErrorFileUrl] = useState(null);
  const fileInputRef = useRef(null);
  const MAX_CALLS = 10;

  // Convert Excel date or string to dd/MM/yyyy
  const formatExcelDate = (value) => {
    if (!value) return '';
    if (typeof value === 'number') {
      const dateCode = XLSX.SSF.parse_date_code(value);
      if (dateCode) {
        return `${String(dateCode.d).padStart(2, '0')}/${String(dateCode.m).padStart(2, '0')}/${dateCode.y}`;
      }
    }
    if (typeof value === 'string') return value.trim();
    return '';
  };

  const formatString = (value) => (value === null || value === undefined ? '' : String(value).trim());

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target?.result;
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      const formattedData = rawData.map((row) => ({
        ...row,
        BOOK_DATE: formatExcelDate(row.BOOK_DATE),
        DispatchDate: formatExcelDate(row.DispatchDate),
        CUSTOMER_CODE: formatString(row.CUSTOMER_CODE),
      }));

      setExcelData(formattedData);
      setProgress(0);
      setErrorFileUrl(null);
    };
    reader.readAsBinaryString(file);
  };
  const handleUpload = async () => {
  if (excelData.length === 0) {
    Swal.fire('No Data', 'Please select an Excel file first.', 'warning');
    return;
  }

  // ✅ Get LocationCode from localStorage
  const locationCode = JSON.parse(localStorage.getItem("Login")).Branch_Code;

  if (!locationCode) {
    Swal.fire('Missing Location', 'LocationCode not found in local storage.', 'error');
    return;
  }

  setUploading(true);
  setProgress(0);
  setErrorFileUrl(null);

  const chunkSize = Math.ceil(excelData.length / MAX_CALLS);
  let successCount = 0;
  let errorFile = null;

  for (let i = 0; i < MAX_CALLS; i++) {
    const chunk = excelData.slice(i * chunkSize, (i + 1) * chunkSize);
    if (chunk.length === 0) continue;

    try {
      // ✅ Send LocationCode with exelData
      const response = await postApi('/Booking/ExcelimportBulkData', {
        exelData: chunk,
        LocationCode: locationCode
      });

      if (response.errorFileUrl) errorFile = response.errorFileUrl;
      if (response.status === 1) successCount += chunk.length;

    } catch (err) {
      console.error(`Chunk ${i + 1} failed`, err);
    }

    setProgress(Math.min(100, ((i + 1) / MAX_CALLS) * 100));
  }

  setUploading(false);
  setErrorFileUrl(errorFile);

  Swal.fire(
    successCount > 0 ? 'Upload Complete' : 'Upload Failed',
    successCount > 0
      ? `✅ ${successCount} of ${excelData.length} rows uploaded.` +
        (errorFile ? " ⚠️ Some errors occurred, download error log." : "")
      : '❌ All rows failed to upload.',
    successCount > 0 ? 'success' : 'error'
  );

  setExcelData([]);
  if (fileInputRef.current) fileInputRef.current.value = '';
};
const handleDownloadTemplate = () => {
  const link = document.createElement("a");
  link.href = excelFile;
  link.download = "sample.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  };


  const handleDownloadErrorFile = () => {
    if (errorFileUrl) {
      const link = document.createElement("a");
      link.href = errorFileUrl;
      link.download = errorFileUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '500px', margin: 'auto' }}>
      <h3>📤 Excel Upload (10 API Calls)</h3>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileChange}
        className="form-control mb-3"
      />
     <div className="row" style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"10px"}}>
         <button
        onClick={handleUpload}
        disabled={uploading || excelData.length === 0}
        className="btn btn-primary col-10 col-md-4"
      >
        {uploading ? 'Uploading...' : 'Start Upload'}
      </button>
        <button onClick={handleDownloadTemplate} 
        className="btn btn-success col-10 col-md-6">
          ⬇️ Download Template
        </button>
      </div>

      {uploading && (
        <div>
          <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '20px' }}>
            <div
              style={{
                width: `${progress}%`,
                backgroundColor: '#4caf50',
                height: '100%',
                borderRadius: '4px',
                transition: 'width 0.5s ease-in-out',
              }}
            />
          </div>
          <p className="text-center mt-2">{progress}% completed</p>
        </div>
      )}

      {errorFileUrl && !uploading && (
        <div className="mt-3 text-center">
          <button onClick={handleDownloadErrorFile} className="btn btn-danger">
            ⬇️ Download Error Log
          </button>
        </div>
      )}
    </div>
  );
};

export default TrackingBulk;
